import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault('America/New_York');
export const TIMEZONES = {
  EASTERN: 'America/New_York',
  CENTRAL: 'America/Chicago',
  PACIFIC: 'America/Los_Angeles',
  MOUNTAIN: 'America/Denver',
};

export enum DAYS {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

// Returns the next 10 calendar days starting from tomorrow
export const WORKING_DAYS = () => {
  const days = [];
  for (let i = 1; i <= 10; i += 1) {
    days.push(dayjs().add(i, 'day'));
  }
  return days;
};

export const isDisabled = (day: dayjs.Dayjs): boolean => {
  if (day.day() === DAYS.SATURDAY || day.day() === DAYS.SUNDAY) {
    return true;
  }
  if (day.isBefore(dayjs(), 'day')) {
    return true;
  }
  if (day.isAfter(dayjs().add(10, 'day'), 'day')) {
    return true;
  }
  return false;
};

export const WORKING_HOURS = {
  eastern: [
    dayjs().hour(9).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(10).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(11).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(12).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(13).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(14).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(15).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(16).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(17).tz(TIMEZONES.EASTERN, true),
    dayjs().hour(18).tz(TIMEZONES.EASTERN, true),
  ],
  central: [
    dayjs().hour(8).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(9).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(10).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(11).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(12).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(13).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(14).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(15).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(16).tz(TIMEZONES.CENTRAL, true),
    dayjs().hour(17).tz(TIMEZONES.CENTRAL, true),
  ],
  pacific: [
    dayjs().hour(6).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(7).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(8).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(9).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(10).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(11).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(12).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(13).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(14).tz(TIMEZONES.PACIFIC, true),
    dayjs().hour(15).tz(TIMEZONES.PACIFIC, true),
  ],
  mountain: [
    dayjs().hour(7).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(8).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(9).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(10).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(11).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(12).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(13).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(14).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(15).tz(TIMEZONES.MOUNTAIN, true),
    dayjs().hour(16).tz(TIMEZONES.MOUNTAIN, true),
  ],
};

export const DAYJS_FORMAT_DATETIME = 'YYYY-MM-DDTHH:mm:ss';

export const DAYJS_DATE_FORMAT = 'MMMM DD, YYYY';

export const DAYJS_SHORTDATE_FORMAT = 'MM/DD/YY';

export const DAYJS_TIME_FORMAT = 'HH:mm A z';

export const DAYJS_DATE_AND_TIME = 'MMMM\xa0DD, YYYY - hh:mm\xa0A z'; // \xa0 stands for unicode for no break space

export const DAYJS_SHORTDATE_AND_TIME = 'MM/DD/YY - hh:mm\xa0A z'; // \xa0 stands for unicode for no break space

export const DAYJS_JOB_INTERVIEW_DATE_FORMAT = 'YYYY-MM-DD';

export const DAYJS_ADMIN_TOOLTIP = 'MMMM DD, hhA z';

export const SEARCH_CANDIDATES_SHORTDATE = 'MM/DD/YYYY';
